import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { ToastrNotificationService } from '../service/toastr-notification.service';

@Injectable()
export class AuthconfigInterceptor implements HttpInterceptor {
  private isHandling401 = false;

  constructor(
    private authService: AuthService,
    private toastr: ToastrNotificationService,
    private dialog: MatDialog
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    // Skip auth header for static assets (like config.json)
    if (req.url.includes('assets/')) {
      return next.handle(req);
    }

    const authToken = this.authService.getToken();
    if (authToken && authToken !== 'null' && authToken !== 'undefined') {
      req = req.clone({
        setHeaders: {
          authorization: 'Bearer ' + authToken,
        },
      });
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (!this.isHandling401) {
            this.isHandling401 = true;
            this.dialog.closeAll();
            this.toastr.warning(
              'Your session has expired. Please log in again to continue.',
              'Session Expired'
            );
            this.authService.doLogout();
            setTimeout(() => {
              this.isHandling401 = false;
            }, 2500);
          }
        }
        return throwError(() => error);
      })
    );
  }
}
